














































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'ProductClassCard',
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
      teacherTaxRates: 'product/teacherTaxRates',
      showProductCustomFields: 'user/showProductCustomFields',
      productTags: 'product/productTags',
    }),
    productName: {
      get(): string {
        return this.productForm.product_name;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_name: value,
        });
      },
    },
    productDescription: {
      get(): string {
        return this.productForm.product_description;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_description: value,
        });
      },
    },
    productDescriptionNew: {
      get(): string {
        return this.productForm.product_description_new;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_description_new: value,
        });
      },
    },
    numberOfPunches: {
      get(): number {
        return this.productForm.number_of_punches;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          number_of_punches: value,
        });
      },
    },
    punchcardExpirationDays: {
      get(): number {
        return this.productForm.punchcard_expiration_days;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          punchcard_expiration_days: value,
        });
      },
    },
    coverFile: {
      get(): number {
        return this.productForm.cover_file;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          cover_file: value,
        });
      },
    },
    thumbnailFile: {
      get(): PhotoResponse {
        return this.productForm.thumbnail_file;
      },
      set(value: PhotoResponse): void {
        this.$store.dispatch('product/setProductForm', {
          thumbnail_file: value,
        });
      },
    },
    mappedTeacherTaxRates() {
      if (!this.teacherTaxRates) return [];
      return this.teacherTaxRates
        .filter(taxRate => taxRate.active)
        .map(taxRate => {
          return {
            ...taxRate,
            name: `${taxRate.name} (${taxRate.rate}%)`,
          };
        });
    },
    custom1: {
      get(): string {
        return this.productForm.custom1;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          custom1: value,
        });
      },
    },
    custom2: {
      get(): string {
        return this.productForm.custom2;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          custom2: value,
        });
      },
    },
    custom3: {
      get(): string {
        return this.productForm.custom3;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          custom3: value,
        });
      },
    },
    mediaNewTagDays: {
      get(): number {
        return this.productForm.media_new_tag_days as number;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          media_new_tag_days: value,
        });
      },
    },
  },
});
